import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CHECKOUT_URL, PRICE } from '../data/content';
export function StickyCta() {
  return <div className="fixed inset-x-0 bottom-0 z-40 border-t border-ink-700 bg-ink-950/95 p-3 backdrop-blur sm:hidden" data-id="element-137" data-mp="3bnp0imk09k6k">
      <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="flex w-full items-center justify-center gap-2 rounded-xl bg-shield-500 px-4 py-3.5 font-display text-sm font-extrabold uppercase tracking-tight text-ink-950 focus:outline-none focus-visible:ring-4 focus-visible:ring-shield-500/40" data-id="element-138" data-mp="2xofl3p3miu3n">
        <ShieldCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-139" data-mp="3gl721rvp0x4j" />
        Quiero mi escudo · {PRICE}
      </a>
    </div>;
}